// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const fermentationProtocolParameterLegacyArchiveId = (z.number());
export const fermentationProtocolParameterLegacyArchive = z.object({
    id: fermentationProtocolParameterLegacyArchiveId,
    default_unit: z.string().nullable(),
    default_ramp_from: z.string().nullable(),
    default_start_time_h: z.string().nullable(),
});
export const fermentationProtocolParameterLegacyArchiveInitializer = z.object({
    id: fermentationProtocolParameterLegacyArchiveId,
    default_unit: z.string().optional().nullable(),
    default_ramp_from: z.string().optional().nullable(),
    default_start_time_h: z.string().optional().nullable(),
});
export const fermentationProtocolParameterLegacyArchiveMutator = z.object({
    id: fermentationProtocolParameterLegacyArchiveId.optional(),
    default_unit: z.string().optional().nullable(),
    default_ramp_from: z.string().optional().nullable(),
    default_start_time_h: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationProtocolParameterLegacyArchive.js.map